module.exports = __webpack_public_path__ + "img/talent_02.a7c6e420.png";